import {getTranslation} from "../../../helpers/translations";

function isFieldValid(field) {
    if (field === undefined || field === 0 || field === null || field === '') {
        return 0;
    }

    return 1
}

export default function calculateCompleteness(product) {
    let variationFields = [];

    if (Array.isArray(product.variations) && product.variations[0]) {
        const variation = product.variations[0];

        variationFields.push(getTranslation(variation).name)
        variationFields.push(variation.retailerOptionValues?.length)
    }

    const fields = [
        product.brand?.id,
        product.categories?.length,
        product.taxRate,
        product.currency,
        product.pictures?.length,
        getTranslation(product).name,
        getTranslation(product).description,
        ...variationFields
    ]

    const validFieldsCount = fields.reduce((accumulator, field) => accumulator + (isFieldValid(field)), 0);

    return Math.round((validFieldsCount / fields.length) * 100);
}
